import React from 'react'
import { useHistory } from 'react-router-dom'
import { Result, Button } from 'antd'

export default function Page404() {
  const history = useHistory()

  const handleBack = () => {
    history.goBack()
  }

  return (
    <Result
      status="404"
      title="404"
      subTitle="您访问的页面不存在或者页面已下线"
      extra={
        <Button onClick={handleBack}>
          返回上一页
        </Button>
      }
    />
  )
}
